import createOpeningTimes from './createOpeningTimes';
export default createOpeningTimes;
